import React from "react";
import { useNavigate } from "react-router-dom";
import BlockIcon from "@mui/icons-material/Block";

/**
 * Landing page reached when the BE returns 403 with `code: "subscription_inactive"`.
 *
 * The api.ts interceptor clears the JWT before redirecting here, so this page is intentionally unauthenticated. It tells the user the tenant has been deactivated and what to do next (contact support). A "Back to login" link covers the case where the user thinks the deactivation was a mistake.
 */
const AccountDeactivatedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-svh flex items-center justify-center p-6 bg-white">
      <div
        style={{
          boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
        }}
        className="max-w-[480px] w-full bg-white rounded-xl p-8 text-center"
      >
        <div
          className="w-16 h-16 mt-0 mx-auto mb-4 rounded-full bg-[#fee2e2] text-[#b91c1c] flex items-center justify-center"
        >
          <BlockIcon style={{ fontSize: 36 }} />
        </div>
        <h1 className="text-[22px] font-bold mb-3">
          Account deactivated
        </h1>
        <p className="text-[#4b5563] leading-[1.5] mb-6">
          Your organization's account has been deactivated and the application
          is no longer accessible. If you believe this is a mistake, please
          contact support to restore access.
        </p>
        <div
          className="flex gap-3 justify-center flex-wrap"
        >
          <a
            href="mailto:isadora.m@scopicsoftware.com"
            style={{
              textDecoration: "none",
            }}
            className="py-2.5 px-[18px] rounded-full bg-[#6d28d9] text-white font-semibold"
          >
            Contact support
          </a>
          <button
            onClick={() => navigate("/login")}
            className="py-2.5 px-[18px] rounded-full bg-transparent border border-solid border-neutral-300 text-[#374151] font-semibold cursor-pointer"
          >
            Back to login
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountDeactivatedPage;
